import {connect} from "react-redux";
import ProductWaitingListPage from "./ProductWaitingListPage";
import * as ViewActions from "../actions/ViewActions";
import {withRouter} from "react-router";

export default connect(null, {...ViewActions})(withRouter(ProductWaitingListPage));